var alignment_rtlignore_default = {
  "alignLeft": "frdxy",
  "textWrapNowrap": "nWDzn",
  "alignRight": "DAR9q",
  "alignCenter": "K5-ee",
  "sizeFullWidth": "_9L9n-",
  "renderedInTable": "fH-pJ",
  "sizeOriginal": "P-Klu",
  "sizeContent": "W3kHZ",
  "sizeSmall": "YzsQs",
  "sizeSmallCenter": "M6Cmi",
  "flex": "_34Fso",
  "LEFT": "BJ4O6",
  "CENTER": "wqojG",
  "RIGHT": "UH2zh",
  "AUTO": "zx6b1",
  "JUSTIFY": "-kfo2"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
